import { Prisma } from '@prisma/client';

import { isProviderBookingConfirmed } from '../quote/is-provider-booking-confirmed';
import { isSpot } from '../quote-variant/is-spot';
import { bookedQuote, bookedVariant } from './booked-quote';

/** Whether what the request was booked on is a spot rate. */
export const isSpotBooking = (
  request?: Prisma.RequestGetPayload<{ select: { booked_quote_variant: { select: { id: true } } } }> | null,
  quotes?:
    | Prisma.QuoteGetPayload<{
        select: { quote_variants: { select: { id: true; line_items: { select: { type: true } } } } };
      }>[]
    | null,
): boolean => isSpot(bookedVariant(request, quotes));

/** A spot booking the provider has not been told about yet. */
export const isUnconfirmedSpotBooking = (
  request?: Prisma.RequestGetPayload<{ select: { booked_quote_variant: { select: { id: true } } } }> | null,
  quotes?:
    | Prisma.QuoteGetPayload<{
        select: {
          provider_booking_confirmed_at: true;
          quote_variants: { select: { id: true; line_items: { select: { type: true } } } };
        };
      }>[]
    | null,
): boolean => isSpotBooking(request, quotes) && !isProviderBookingConfirmed(bookedQuote(request, quotes));

/**
 * Worth nagging about: the AWB is what makes it urgent, because from then on the provider has a live booking they will
 * bill at the standard rate unless they are told the spot rate was accepted.
 */
export const needsProviderSpotConfirmation = (
  request?: Prisma.RequestGetPayload<{ select: { booked_quote_variant: { select: { id: true } } } }> | null,
  quotes?:
    | Prisma.QuoteGetPayload<{
        select: {
          awb_number: true;
          provider_booking_confirmed_at: true;
          quote_variants: { select: { id: true; line_items: { select: { type: true } } } };
        };
      }>[]
    | null,
): boolean => isUnconfirmedSpotBooking(request, quotes) && !!bookedQuote(request, quotes)?.awb_number;
